import { CxsBasket, errorMessages } from '../model';
import { markProductUpdate, updateEntry } from '../utils';
import { BasketLine } from '@models/api-orders.models';

export const updateGiftWrappingOptions = (
    basket: CxsBasket,
    productId: string,
    newGiftWrappingId?: string,
    newGiftCardId?: string,
    newGiftCardText?: string
): CxsBasket => {
    const existingLineIndex = basket.lines.findIndex(currentLine => currentLine.variantNo === productId);
    const line = basket.lines[existingLineIndex];
    if (!line) {
        throw Error(errorMessages.productNotFound);
    }

    const giftOptions: Partial<Pick<BasketLine, 'giftWrappings' | 'giftWrappingsCard' | 'giftWrappingsCardText'>> = {};

    giftOptions.giftWrappings = newGiftWrappingId ? [newGiftWrappingId] : [];
    giftOptions.giftWrappingsCard = newGiftCardId ? newGiftCardId : undefined;
    giftOptions.giftWrappingsCardText = newGiftCardId ? newGiftCardText : undefined;

    const lines = updateEntry(basket.lines, { ...giftOptions }, existingLineIndex);
    return {
        ...basket,
        lines,
        ...markProductUpdate(basket, productId)
    };
};
